var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5A.5.5 0 0 0 9 9v2a.5.5 0 0 1-.5.5H7V4c0-.427-.272-.809-.681-.95L6.171 3H8.5a.5.5 0 0 1 .5.5V5a.5.5 0 1 0 1 0V3.5C10 2.673 9.327 2 8.5 2H3.125c-.019 0-.035.009-.053.011C3.047 2.009 3.024 2 3 2c-.551 0-1 .448-1 1v9c0 .427.272.808.681.95l3.009 1.004Q5.841 14 6 14a1 1 0 0 0 1-1v-.5h1.5c.827 0 1.5-.673 1.5-1.5V9a.5.5 0 0 0-.5-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.854 6.646-2-2A.5.5 0 0 0 11 5v1.5H9a.5.5 0 0 0 0 1h2V9a.501.501 0 0 0 .854.354l2-2a.5.5 0 0 0 0-.708"
  })));
};
export default SvgLogout;